import React from 'react';
import { Sun, Moon } from 'lucide-react';

const LangButton = ({ code, active, onClick, testId }) => (
  <button
    data-testid={testId}
    onClick={onClick}
    className={`px-4 py-1.5 rounded-md text-sm font-semibold transition-colors duration-200 ${
      active ? 'bg-[var(--lux-gold)] text-[var(--lux-ink)]' : 'text-[var(--lux-text-secondary)] hover:text-[var(--lux-text)]'
    }`}
  >
    {code.toUpperCase()}
  </button>
);

/** Compact brand + language + theme bar shown above the auth forms. */
export const AuthTopBar = ({ language, setLanguage, theme, toggleTheme }) => (
  <div className="flex justify-between items-center mb-8 max-w-md w-full mx-auto">
    <div className="lg:hidden flex items-center gap-2">
      <img src="/logo.jpeg" alt="PrimeFace" className="w-8 h-8 rounded-lg object-cover border border-lux-gold/30" />
      <span className="font-display text-lg text-white">PrimeFace</span>
    </div>
    <div className="lg:ml-auto flex items-center bg-[var(--lux-panel)] rounded-lg border border-white/[0.08] p-0.5">
      <LangButton code="fr" active={language === 'fr'} onClick={() => setLanguage('fr')} testId="lang-fr-button" />
      <LangButton code="en" active={language === 'en'} onClick={() => setLanguage('en')} testId="lang-en-button" />
    </div>
    <button
      data-testid="auth-theme-toggle"
      onClick={toggleTheme}
      className="flex items-center justify-center w-9 h-9 rounded-lg bg-[var(--lux-panel)] border border-[var(--lux-border)] text-[var(--lux-text-secondary)] hover:text-[var(--lux-gold)] transition-colors duration-200"
      title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
    >
      {theme === 'dark' ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  </div>
);
